import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import classNames from 'classnames/bind';
import styles from './WebPlayer.scss';
const cx = classNames.bind(styles);

@withRouter
class WebPlayer extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    const tProps = {
      user: this.props.user,
      title: this.props.status,
      handle: this.props.handle,
      status: this.props.status,

      artist: this.props.player,
      repeatList: this.props.repeatList,
      history: this.props.history,
      hasWebplayer: this.props.hasWebplayer,
      pushModal: this.props.pushModal,
    };
    const nProps = {
      user: nextProps.user,
      title: nextProps.status,
      handle: nextProps.handle,
      status: nextProps.status,
      artist: nextProps.player,
      repeatList: nextProps.repeatList,
      history: nextProps.history,
      hasWebplayer: nextProps.hasWebplayer,
      pushModal: nextProps.pushModal,
    };

    return JSON.stringify(tProps) !== JSON.stringify(nProps);
  }

  transformTime = second => {
    let min = `0`;
    let sec = `00`;
    if (this.props.player) {
      min = this.makeInteger(second / 60 - 1);
      sec = this.makeTwoDigits(this.makeInteger(second % 60));
    }
    return `${min}:${sec}`;
  };

  makeTwoDigits = number => {
    let res = `${number}`;
    if (res.length < 2) res = `0${res}`;
    return res;
  };

  makeInteger = number => {
    if (number < 0) number = 0;
    return Math.ceil(number);
  };

  /**
   * Mouse Event Control
   */
  dragEventStatus = '';
  dragEvent = {};
  getMousePosition = (e, bool) => {
    if (bool) {
      const targetElement = document.getElementById(this.dragEventStatus);
      const { width, left } = targetElement.getBoundingClientRect();
      let position = ((e.clientX - left) / width) * 100;
      return position;
    }
  };
  changeCamelCase = (text = '') => {
    let camel = '';
    if (text) {
      camel = text.split('');
      camel[0] = camel[0].toUpperCase();
      camel = camel.join('');
    }
    return camel;
  };
  setEventPosition = (eventName, position) => {
    this.props.handle[`set${this.changeCamelCase(eventName)}`](position);
  };
  handleMouseDown = (e, type = '') => {
    this.dragEventStatus = type;
    if (this.dragEventStatus) {
      this.dragEvent.position = this.getMousePosition(e, this.dragEventStatus);
    }
    return;
  };
  handleMouseMove = e => {
    if (this.dragEventStatus) {
      const position = this.getMousePosition(e, this.dragEventStatus);
      if (position) {
        this.setEventPosition(this.dragEventStatus, position);
        this.dragEvent.position = position;
      }
    }
    return;
  };
  handleMouseUp = e => {
    const { position } = this.dragEvent;
    if (position) this.setEventPosition(this.dragEventStatus, position);
    this.dragEventStatus = '';
    this.dragEvent = {};
    return;
  };

  handleDrawPlaylist = () => {
    let playlist = this.props.handle.getPlaylist();
    const index = this.props.handle.getPlaylistIndex();
    if (playlist) {
      playlist = playlist.map((item, i) => {
        item.active = i === index;
        return item;
      });
    }
  };

  linkToPlayPage = () => {
    const { status } = this.props;
    const { upc, action } = status;
    const { getType, search = {} } = action;
    const path = `/player/${upc}/play?${getType ? `getType=${getType}&` : ''}${
      search.type ? `moodType=${search.type}&` : ''
    }${search.value ? `value=${search.value}` : ''}`;
    this.props.history.push(path);
  };

  play = async () => {
    const { handle } = this.props;
    await handle.actionPlay();
  };
  pause = async () => {
    const { handle } = this.props;
    await handle.actionPause();
  };
  prev = async () => {
    const { handle } = this.props;
    await handle.actionPrev();
  };
  next = async () => {
    const { handle } = this.props;
    await handle.actionNext();
  };

  userPerchaseCheck = fn => {
    const { user = {}, pushModal } = this.props;
    if (user.userPurchase === 'PAID') {
      if (typeof fn === 'function') {
        return fn();
      } else {
        // console.error('userPurchase - fn is not function');
      }
    } else {
      pushModal({
        type: 'Consultation',
      });
    }
  };

  render() {
    const { status = {}, handle = {}, player, repeatList = [] } = this.props;

    const {
      upc,
      title,
      artist,
      artistEng,
      image,
      // playing,
      mute,
      shuffle,
      repeat = 0,
      volume,
      timestamp = {},
      playlist = [],
      playItemOption = [],
      disable = true,
    } = status;
    const { current = 0, duration = 0, percent = 0 } = timestamp;

    // Style
    const thumbStyle = {
      backgroundImage: `url("${image}")`,
    };
    const volumeBarSyle = {
      width: mute ? 0 : volume + '%',
    };
    const timelineBarSyle = {
      width: percent + '%',
    };

    //////

    let start = 0;
    let end = 0;

    if (this.props.player) {
      const index = this.props.player.getPlaylistIndex();
      const playlist = this.props.player.getPlaylist();
      const item = playlist[index];
      if (item.start) start = item.start;
      if (item.end) {
        end = duration - item.end;
      }
    }

    const point = current - start;
    const length = duration - start - end;

    // Timestamp
    const timestampObj = {
      current: this.transformTime(point),
      duration: this.transformTime(length),
    };

    let nowPlaying = false;
    if (player) {
      let state = player.getState();
      nowPlaying = state === 'playing' ? true : false;
    }

    const idx = playlist.findIndex(me => {
      return me.upc === upc;
    });
    let item = {};
    let selected = false;
    if (playItemOption[idx]) item = playItemOption[idx];
    if (item.userPlayListChoice) selected = item.userPlayListChoice;

    return (
      <div className={cx('web-player', `disable-${disable}`)}>
        <div
          className="web-player-controler"
          onMouseMove={this.handleMouseMove}
          onMouseUp={this.handleMouseUp}
        >
          {/* <div id="test-div" /> */}
          <div className="wp-control">
            <div className="info" onClick={this.linkToPlayPage}>
              <span className="thumb" style={thumbStyle} />
              <div className="song">
                <span className="title">{title}</span>
                <span className="singer">
                  {artist} {artistEng ? `(${artistEng})` : ''}
                </span>
              </div>
            </div>
            <div className="controller">
              <div
                className={`shuffle shuffle-${shuffle}`}
                onClick={() => this.userPerchaseCheck(handle.actionShuffle)}
              >
                <span className="icon" />
              </div>
              <div className="prev-play" onClick={this.prev}>
                <span className="icon" />
              </div>
              <div
                className={`toggle-play isplay-${nowPlaying}`}
                onClick={() =>
                  this.userPerchaseCheck(nowPlaying ? this.pause : this.play)
                }
              >
                <span className="icon" />
              </div>
              <div className="next-play" onClick={this.next}>
                <span className="icon" />
              </div>
              <div
                className={`repeat-list repeat-${
                  repeatList[repeat] ? repeatList[repeat].name : 'NONE'
                }`}
                onClick={() => this.userPerchaseCheck(handle.actionRepeat)}
              >
                <span className="icon" />
              </div>
            </div>

            <div
              id="timeline"
              className="timeline-container"
              onMouseDown={e =>
                this.userPerchaseCheck(this.handleMouseDown(e, 'timeline'))
              }
            >
              <span className="current">{timestampObj.current}</span>
              <div className="timeline-bar">
                <div className="bar" style={timelineBarSyle}>
                  <div className="control-point" />
                </div>
              </div>
              <span className="end">{timestampObj.duration}</span>
            </div>

            <div className="options">
              <div
                className={`playlist ${selected ? 'active' : ''}`}
                // onClick={() => handle.setPlaylist(samplePlayList)}
                // onClick={this.handleDrawPlaylist}
                onClick={() => this.userPerchaseCheck(handle.toggleMyList)}
              >
                <span className="icon" />
              </div>
              <div className="volume">
                <div
                  className={`toggle-mute isMuted-${
                    mute ? true : volume > 0 ? false : true
                  }`}
                  onClick={() => this.userPerchaseCheck(handle.setToggleMute)}
                >
                  <span className="icon" />
                </div>
                <div
                  id="volume"
                  className="volume-container"
                  onMouseDown={e => this.handleMouseDown(e, 'volume')}
                >
                  <div className="volume-bar">
                    <div className="bar" style={volumeBarSyle}>
                      <div className="control-point" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WebPlayer;
